// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__CoyL2","title":"Info_title__1Npdv","selects":"Info_selects__aIyvp","requiredAsterisk":"Info_requiredAsterisk__2nbVM"};